import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import Modal from '@mui/material/Modal';
import './AlertSuccess.scss';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { apisPath, paths } from '../../../utils/path';
import { authHttp } from '../../../components/services/utility';

/* eslint-disable global-require */
const AlertSuccess = (_props) => {
  const navigate = useNavigate()
  // const { details, onDone, handleOpen } = _props;

  // const [open, setOpen] = React.useState(handleOpen);
  const { alertState, setAlertState, deleteAuthState, setIsLoading } = useContext(AuthContext)

  const handleClose = () => {
    if (alertState?.path) {
      navigate(alertState?.path)
    }
    if (alertState?.isSessionExpire) {
      setIsLoading(false)
      if (alertState?.sessionType === 'admin') {
        deleteAuthState('admin-token')
        navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.login}`)
      }
      else {
        authHttp.get(apisPath?.front?.user?.logout)
        setTimeout(()=>{
          deleteAuthState("app-token");
          navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.login}`);
        },1000)
      }
    }
    setAlertState({
      open: false,
      title: '',
      isSessionExpire: false,
      btnTxt: '',
      status: 'success'
    })
  };


  const icon = require(`../../../assets/${alertState?.status}.png`)
  const btnClass = `alert-${alertState?.status}--button`
  return <Modal
    open={alertState?.open}
    // onClose={handleClose}
    className="customModal"
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <div className="alert-fail">
      <Box className="alert-fail--box">
        <div className="alert-fail--header">
         <h2>Message Box</h2>
        </div>
        <div className="alert-fail--message">
          <p>
            {Array.isArray(alertState.title) ?
              alertState.title.map((error) => {
                return <><span>{error}</span><br /></>
              })
              : alertState.title}
          </p>
        </div>
        <div className={btnClass}>
          <Button variant='contained' onClick={handleClose}>{alertState.btnTxt}</Button>
        </div>
      </Box>
    </div>
  </Modal>
};


export default AlertSuccess;
